<!-- <phx-row class="center">
  <div class="library-header">
    <div class="bread-crumbs">
      <div class="custom lrg link padding left" [ngClass]="{ 'bold': selectedBook }" (click)="goToLibrary()">
        Library
      </div>
      <i *ngIf="selectedBook" class="material-icons">keyboard_arrow_right</i>
      <div *ngIf="selectedBook" class="custom lrg">
        Book
      </div>
      <div *ngIf="selectedBook" class="caption padding sm left">
        {{selectedBook.assignmentString}}
      </div>
    </div>

    <phx-search class="padding right" *ngIf="!killSearch && !library?.processing" (onSearch)="filter($event)">
    </phx-search>
  </div>
</phx-row> -->

<!-- Library -->
<div *ngIf="!selectedBook && library">
  <div [@slideInOnlyUpStaggered]="library?.books?.length" class="books-container scroll">
    <div class="book-item" *ngFor="let book of sortedBooks" (click)="selectBook(book)">
      <app-library-list-item [libraryItemData]="convertToListItem(book)"> </app-library-list-item>
    </div>
  </div>
</div>

<!-- No Books -->
<app-nothing-here margin="128" *ngIf="library?.books?.length === 0">
  <h5 *ngIf="!library?.processing">{{ selectedMasterKey.keySetSymbol }} has no books yet.</h5>
</app-nothing-here>

<!-- Book -->
<div class="book-wrapper" *ngIf="selectedBook">
  <div class="col">
    <!-- Key list -->
    <!-- <phx-row class="key-filter-tool-bar" justify="flex-end" flex="0">
    
    <lib-key *ngIf="selectedFilterKey?.id" class="margin left" [hierarchyItem]="selectedFilterKey"></lib-key>

    <div *ngIf="!selectedFilterKey?.id" class="no Filter">All</div>

    <button
      mat-icon-button
      [matMenuTriggerFor]="actions">
      <mat-icon>filter_list_outline</mat-icon>
    </button>
  
    <mat-menu #actions>
      <button mat-menu-item
        (click)="clearFilter()">
        <mat-icon>assignment_outline</mat-icon>Show All
      </button>
      <button mat-menu-item
        (click)="filterKeyList(crossKey)"
        *ngFor="let crossKey of selectedMasterKey.crossKeyAssignments">
        <mat-icon>assignment_outline</mat-icon>{{crossKey.keySetSymbol}} Opperators
      </button>
    </mat-menu>

    <phx-button

      [outline]="selectedKbaArray.length > 0"
      [small]="true"
      class="margin left">
        Unassign
      </phx-button>
      
      <phx-button [color]="'#393E46'"

        [outline]="false"
        [small]="true"
        class="margin left">
        Assign
      </phx-button>

      <button
        mat-icon-button
>
        <mat-icon>more_vert</mat-icon>
      </button>

  </phx-row> -->

    <div class="key-list-scroll">
      <div class="col" style="width: 100%">
        <div
          cdkDropList
          class="padding bottom left right top"
          id="keysList"
          [cdkDropListData]="selectedMasterKey?.children"
          (cdkDropListDropped)="dropUnassignedList($event)"
          [cdkDropListConnectedTo]="connectedTo"
        >
          <div
            class="margin bottom"
            [cdkDragData]="key"
            (cdkDragStarted)="dragStart(key)"
            [cdkDragDisabled]="key.assignment?.kba || (key.isAssigned && !key.unassignedLocally)"
            [ngClass]="{
              'kba-disabled': !canAssign(kba) && dragging
            }"
            cdkDrag
            *ngFor="let key of selectedMasterKey?.children"
          >
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <div *ngIf="keyingLibraryService.selectedKeySection$ | async; let selectedKeySection">
              <div *ngIf="selectedKeySection && showControlKeysMaster(selectedMasterKey)">
                <lib-key
                  class="grab"
                  [hierarchyItem]="key"
                  [disabled]="(key.isAssigned && !key.unassignedLocally) || key.isAssignedLocally"
                  *ngIf="key.masterKeyTypeId === keyNodeType.ControlKeyMaster"
                >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is Assigned"
                    class="margin sm left"
                    color="green"
                    *ngIf="
                      key.assignment?.kba || ((key?.isAssigned || key?.isAssignedLocally) && !key.unassignedLocally)
                    "
                    >check</mat-icon
                  >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is a Cross Key Operator"
                    class="padding xsm left"
                    *ngIf="key?.isCrossKeyOperator"
                    >key</mat-icon
                  >
                </lib-key>
              </div>
              <div
                *ngIf="
                  key.inFilter &&
                  selectedKeySection &&
                  selectedKeySection.keywayTypeId === keywayType.Elevated &&
                  !showControlKeysMaster(selectedMasterKey)
                "
              >
                <lib-key
                  class="grab"
                  [hierarchyItem]="key"
                  [disabled]="(key.isAssigned && !key.unassignedLocally) || key.isAssignedLocally"
                  *ngIf="
                    key.masterKeyTypeId === keyNodeType.Master ||
                    key.masterKeyTypeId === keyNodeType.Direct ||
                    key.masterKeyTypeId === keyNodeType.ChangeKey ||
                    key.masterKeyTypeId === keyNodeType.SelectiveMaster ||
                    key.masterKeyTypeId === keyNodeType.ControlKey
                  "
                >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is Assigned"
                    class="margin sm left"
                    color="green"
                    *ngIf="
                      key.assignment?.kba || ((key?.isAssigned || key?.isAssignedLocally) && !key.unassignedLocally)
                    "
                    >check</mat-icon
                  >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is a Cross Key Operator"
                    class="padding xsm left"
                    *ngIf="key?.isCrossKeyOperator"
                    >key</mat-icon
                  >
                </lib-key>
              </div>
              <div
                *ngIf="
                  key.inFilter &&
                  selectedKeySection &&
                  selectedKeySection.keywayTypeId !== keywayType.Elevated &&
                  !showControlKeysMaster(selectedMasterKey)
                "
              >
                <lib-key
                  class="grab"
                  [hierarchyItem]="key"
                  [disabled]="key.isAssigned && !key.unassignedLocally"
                  *ngIf="
                    key.masterKeyTypeId === keyNodeType.Master ||
                    key.masterKeyTypeId === keyNodeType.DirectChangeMaster ||
                    key.masterKeyTypeId === keyNodeType.Direct ||
                    key.masterKeyTypeId === keyNodeType.ChangeKey ||
                    key.masterKeyTypeId === keyNodeType.SingleKeyDifferentMaster ||
                    key.masterKeyTypeId === keyNodeType.SingleKeyDifferent ||
                    key.masterKeyTypeId === keyNodeType.SelectiveMaster ||
                    key.masterKeyTypeId === keyNodeType.ControlKey
                  "
                >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is Assigned"
                    class="margin sm left"
                    color="green"
                    *ngIf="
                      key.assignment?.kba || ((key?.isAssigned || key?.isAssignedLocally) && !key.unassignedLocally)
                    "
                    >check</mat-icon
                  >
                  <mat-icon
                    matTooltipShowDelay="400"
                    matTooltip="Key is a Cross Key Operator"
                    class="padding xsm left"
                    *ngIf="key?.isCrossKeyOperator"
                    >key</mat-icon
                  >
                </lib-key>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col hideOverFlow" style="width: 100%">
    <div class="row center">
      <div class="library-header">
        <div class="padding left" style="display: flex">
          <div class="custom">Total Combinations:</div>
          <div class="caption padding sm left">
            {{ selectedBook?.stats?.total }}
          </div>
        </div>
        <div class="padding left" style="display: flex">
          <div class="custom">Available Combinations:</div>
          <div class="caption padding sm left">
            {{ selectedBook?.stats?.available }}
          </div>
        </div>
        <div class="padding left" style="display: flex">
          <div class="custom">Assigned Combinations:</div>
          <div class="caption padding sm left">
            {{ selectedBook?.stats?.assigned }}
          </div>
        </div>

        <keycom-search class="padding right" *ngIf="!library?.processing" (onSearch)="filter($event)"> </keycom-search>
      </div>
    </div>

    <!-- Pages -->
    <cdk-virtual-scroll-viewport
      class="book-scroll"
      [itemSize]="891"
      minBufferPx="1782"
      maxBufferPx="3564"
      style="height: 100%; width: 100%"
    >
      <div
        class="page"
        [ngClass]="{
          'fixed-page-height': selectedBook?.stats?.total.length > 60
        }"
        *cdkVirtualFor="let page of selectedBook?.pages; let index = index"
      >
        <div class="block-header">
          <div class="row">
            <div class="col flex-center">
              <mat-checkbox [checked]="page.selected" (change)="selectPage($event, page)"></mat-checkbox>
            </div>
            <div class="col flex-center full-width">
              <div class="row center">
                <div class="caption">Page: {{ index + 1 }}</div>
              </div>
            </div>
            <div class="col flex-center">
              <div class="row center">
                <div *ngFor="let column of page.columns; let index = index">
                  <mat-chip
                    *ngIf="column.isMinimized"
                    (click)="column.isMinimized = false"
                    size="auto"
                    class="margin sm right"
                  >
                    {{ index + 1 }}
                  </mat-chip>
                </div>

                <div (click)="page.show = !page.show" class="col minimize center padding sm right">
                  <mat-icon *ngIf="!page.show">expand_less</mat-icon>
                  <mat-icon *ngIf="page.show">expand_more</mat-icon>
                </div>

                <mat-icon
                  *ngIf="canCombinePage(page)"
                  color="#6E6E6E"
                  matTooltipShowDelay="400"
                  matTooltip="Combine Page"
                  class="minimize padding sm left"
                  (click)="combinePage(page)"
                  (mouseenter)="previewCombinePage(page)"
                  (mouseleave)="previewCombinePage(page)"
                  >fullscreen_exit
                </mat-icon>

                <mat-icon
                  *ngIf="canSeparatePage(page) && page.combineType === 3"
                  color="#6E6E6E"
                  matTooltipShowDelay="400"
                  matTooltip="Separate Page"
                  class="minimize padding sm left"
                  (click)="separatePage(page)"
                  >fullscreen
                </mat-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- Columns -->
        <div *ngIf="page.show" class="block-body">
          <div class="row">
            <div *ngFor="let column of page.columns; let index = index" class="column-wrapper">
              <div id="{{ index }}" *ngIf="!column.isMinimized" class="column">
                <div class="block-header">
                  <div class="row">
                    <div class="col flex-center">
                      <mat-checkbox
                        [disabled]="column.disabled"
                        [checked]="column.selected"
                        (change)="selectColumn($event, column, page)"
                      ></mat-checkbox>
                    </div>
                    <div class="col flex-center full-width">
                      <div class="row center flex-space">
                        <div class="caption">Column: {{ index + 1 }}</div>

                        <div class="col">
                          <div class="row center">
                            <div *ngFor="let block of column.blocks; let index = index">
                              <mat-chip
                                *ngIf="block.isMinimized"
                                (click)="block.isMinimized = false"
                                size="auto"
                                class="margin sm right"
                              >
                                {{ index + 1 }}
                              </mat-chip>
                            </div>

                            <mat-icon
                              *ngIf="canCombineColumn(column) && selectedBook.pages.length === 1"
                              color="#6E6E6E"
                              matTooltipShowDelay="400"
                              matTooltip="Combine Column"
                              class="minimize"
                              (click)="combineColumn(column)"
                              (mouseenter)="previewCombineColumn(column)"
                              (mouseleave)="previewCombineColumn(column)"
                              >fullscreen_exit
                            </mat-icon>

                            <!-- Column Combine Menu -->
                            <mat-icon
                              [matMenuTriggerFor]="columnActions"
                              *ngIf="canCombineColumn(column) && selectedBook.pages.length > 1"
                              matTooltipShowDelay="400"
                              matTooltip="Combine Options"
                              class="minimize"
                              >fullscreen
                            </mat-icon>

                            <mat-icon
                              *ngIf="
                                canSeparateColumn(column) && (column.combineType === 2 || column.combineType === 9)
                              "
                              color="#6E6E6E"
                              matTooltipShowDelay="400"
                              matTooltip="Separate Column"
                              class="minimize"
                              (click)="separateColumn(column)"
                              >fullscreen
                            </mat-icon>

                            <!-- Column Combine Actions -->
                            <mat-menu #columnActions>
                              <button
                                mat-menu-item
                                (click)="combineColumn(column)"
                                (mouseenter)="previewCombineColumn(column)"
                                (mouseleave)="previewCombineColumn(column)"
                              >
                                <mat-icon class="phx-to-mat-icon" color="#6E6E6E">fullscreen_exit </mat-icon>Combine
                                Column
                              </button>
                              <button
                                mat-menu-item
                                (click)="combineColumnStack(selectedBook, column)"
                                (mouseenter)="previewCombineColumnStack(selectedBook, column)"
                                (mouseleave)="previewCombineColumnStack(selectedBook, column)"
                              >
                                <mat-icon>compress</mat-icon>Combine Column Stack
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Blocks -->
                <div class="block-body">
                  <div class="col" *ngFor="let block of column.blocks; let blockIndex = index">
                    <div class="block" *ngIf="!block.isMinimized">
                      <div class="block-header">
                        <div class="row">
                          <div class="col flex-center">
                            <mat-checkbox
                              [disabled]="block.disabled"
                              [checked]="block.selected"
                              (change)="selectBlock($event, block, column, page)"
                            ></mat-checkbox>
                          </div>
                          <div class="col flex-center full-width">
                            <div class="row center flex-space">
                              <div class="caption">Block: {{ blockIndex + 1 }}</div>

                              <!-- <phx-col [flex]="0">
                                <phx-row class="center">
                                  <phx-icon *ngIf="canMinimize" class="minimize" [size]="20" iconName="minus" (click)="block.isMinimized = true"></phx-icon>
                              </phx-row>
                              </phx-col> -->

                              <mat-icon
                                *ngIf="
                                  (block.combineType === 1 ||
                                    block.combineType === 6 ||
                                    block.combineType === 8 ||
                                    block.combineType === 10) &&
                                  canSeparateBlock(block)
                                "
                                color="#6E6E6E"
                                matTooltipShowDelay="400"
                                matTooltip="Separate Block"
                                class="minimize"
                                (click)="separateBlock(block)"
                                >fullscreen_exit
                              </mat-icon>

                              <!-- Block Combine Menu -->
                              <mat-icon
                                [matMenuTriggerFor]="blockActions"
                                *ngIf="canCombineBlock(block) && selectedBook.pages[0].columns.length > 1"
                                matTooltipShowDelay="400"
                                matTooltip="Combine Options"
                                class="minimize"
                                >fullscreen_exit
                              </mat-icon>

                              <mat-icon
                                *ngIf="canCombineBlock(block) && selectedBook.pages[0].columns.length === 1"
                                (click)="combineBlock(block)"
                                (mouseenter)="previewCombineBlock(block)"
                                (mouseleave)="previewCombineBlock(block)"
                                matTooltipShowDelay="400"
                                matTooltip="Combine Block"
                                class="minimize"
                                >fullscreen
                              </mat-icon>

                              <!-- Block Combine Actions -->
                              <mat-menu #blockActions>
                                <button
                                  mat-menu-item
                                  (click)="combineBlock(block)"
                                  (mouseenter)="previewCombineBlock(block)"
                                  (mouseleave)="previewCombineBlock(block)"
                                >
                                  <mat-icon class="phx-to-mat-icon" color="#6E6E6E">fullscreen_exit</mat-icon>Combine
                                  Block
                                </button>
                                <button
                                  mat-menu-item
                                  (click)="combineBlocksAcross(page, block)"
                                  (mouseenter)="previewCombineBlocksAcross(page, block)"
                                  (mouseleave)="previewCombineBlocksAcross(page, block)"
                                >
                                  <mat-icon style="transform: rotate(90deg)">unfold_less</mat-icon>Combine Blocks
                                  Horizontally
                                </button>
                                <button
                                  mat-menu-item
                                  *ngIf="selectedBook.pages.length > 1"
                                  (click)="combineBlockStack(selectedBook, column, block)"
                                  (mouseenter)="previewCombineBlockStack(selectedBook, column, block)"
                                  (mouseleave)="previewCombineBlockStack(selectedBook, column, block)"
                                >
                                  <mat-icon>compress</mat-icon>Combine Block Stack
                                </button>
                                <button
                                  mat-menu-item
                                  *ngIf="selectedBook.pages.length > 1"
                                  (click)="combineBlockRowStack(selectedBook, column, block)"
                                  (mouseenter)="previewCombineBlockRowStack(selectedBook, column, block)"
                                  (mouseleave)="previewCombineBlockRowStack(selectedBook, column, block)"
                                >
                                  <mat-icon>compress</mat-icon>Combine Block Row Stack
                                </button>
                              </mat-menu>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- KBAs -->
                      <div
                        class="block-body"
                        cdkDropList
                        (cdkDropListDropped)="dropInBook($event)"
                        [id]="block.id"
                        [cdkDropListData]="block.kbas"
                        [cdkDropListConnectedTo]="connectedTo"
                        (cdkDragEnter)="dragEnter($event)"
                      >
                        <div
                          class="kba"
                          [ngClass]="{
                            'kba-disabled':
                              (!canAssign(kba) && dragging) ||
                              (kba.children && kba.children.length > 0) ||
                              kba.disabled,
                            'is-a-split': kba.isASplit,
                            'is-a-combine': kba.isCombine,
                            'will-combine': kba.willCombine,
                            'will-split': kba.willSplit,
                            error: kba.error
                          }"
                          *ngFor="let kba of block.kbas"
                          (cdkDragStarted)="dragStart(kba?.assignment?.masterKey)"
                          cdkDrag
                        >
                          <!-- Placeholder -->
                          <div class="drag-placeholder" *cdkDragPlaceholder></div>
                          <!-- Preview -->
                          <div *cdkDragPreview>
                            <lib-key [hierarchyItem]="kba?.assignment?.masterKey">
                              <mat-icon
                                matTooltipShowDelay="400"
                                matTooltip="Key is a Cross Key Operator"
                                class="padding xsm left"
                                *ngIf="kba?.assignment?.masterKey?.isCrossKeyOperator"
                                >key</mat-icon
                              >
                            </lib-key>
                            <div class="grab lock" *ngIf="kba?.assignment?.reserved">
                              <mat-icon class="margin sm top bottom">lock</mat-icon>
                            </div>
                          </div>

                          <div class="row full-width" *ngIf="!kba?.hidden">
                            <!-- Checkboxs -->
                            <div class="col flex-center">
                              <mat-checkbox
                                class="padding sm left"
                                [disabled]="kba.disabled || (kba?.children && kba?.children?.length > 0)"
                                [checked]="kba.selected"
                                (change)="selectKba($event, kba, page, column, block)"
                              >
                              </mat-checkbox>
                            </div>

                            <!-- Assignment -->
                            <div
                              class="col flex-center"
                              [ngClass]="{
                                filtered: !kba.show,
                                unfiltered: kba.show
                              }"
                              cdkDragHandle
                            >
                              <div class="row center flex-start">
                                <!-- Lines -->
                                <div
                                  *ngFor="
                                    let level of kba?.lineTracker | keyvalue;
                                    let first = first;
                                    let last = last;
                                    let index = index
                                  "
                                  class="lines"
                                >
                                  <div *ngIf="level.value.key === kba.masterKeyBitting" class="top"></div>
                                  <div class="bottom" [ngClass]="{ 'no-border': level.value.value }"></div>
                                </div>

                                <!-- Bitting Array -->
                                <app-key-bitting-array class="margin sm left right" [kba]="kba"></app-key-bitting-array>

                                <!-- Spacer -->
                                <div
                                  class="arrow margin sm right"
                                  *ngIf="kba?.assignment?.reserved || kba?.assignment?.masterKey"
                                ></div>

                                <!-- Reserved Assignment -->
                                <div [matMenuTriggerFor]="actions" class="grab lock" *ngIf="kba?.assignment?.reserved">
                                  <mat-icon
                                    class="margin sm top bottom"
                                    matTooltip="{{
                                      kba?.assignment?.reservationType.description +
                                        ' - ' +
                                        kba?.assignment?.reservationNote
                                    }}"
                                    >lock</mat-icon
                                  >
                                </div>

                                <!-- Key Assignment -->
                                <lib-key
                                  class="grab margin sm left"
                                  [matMenuTriggerFor]="actions"
                                  *ngIf="kba?.assignment?.masterKey"
                                  [hierarchyItem]="kba?.assignment?.masterKey"
                                >
                                  <mat-icon
                                    matTooltipShowDelay="400"
                                    matTooltip="Key is a Cross Key Operator"
                                    class="padding xsm left"
                                    *ngIf="kba?.assignment?.masterKey?.isCrossKeyOperator"
                                    >key</mat-icon
                                  >
                                </lib-key>

                                <!-- Bitting Actions -->
                                <mat-menu #actions>
                                  <button
                                    mat-menu-item
                                    *ngIf="!kba?.assignment?.masterKey?.id && !kbs?.assignment?.reserved"
                                    [disabled]="kba.hasError || kba.hasWarning"
                                    (click)="assignKbas(kba, true)"
                                  >
                                    <mat-icon class="material-icons-outlined">assignment_outline</mat-icon>Assign
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      kba.hasError ||
                                      (kba.hasWarning && !kba?.assignment?.masterKey?.id && !kba?.assignment?.reserved)
                                    "
                                    [disabled]="kba.hasError"
                                    (click)="assignKbas(kba, false)"
                                  >
                                    <mat-icon>warning_outline</mat-icon>Assign + Guideline Violators
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="!kba?.assignment?.reserved && !kba?.assignment?.masterKey?.id"
                                    (click)="openDialog(1, kba)"
                                  >
                                    <mat-icon>lock_outline</mat-icon>Reserve
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      !kba?.assignment?.reserved && !kba?.assignment?.masterKey?.id && !kba?.isCombine
                                    "
                                    (click)="splitBitting(kba)"
                                    (mouseenter)="previewSplit(kba)"
                                    (mouseleave)="previewSplit(kba)"
                                  >
                                    <mat-icon>call_split</mat-icon>Split
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      !kba?.assignment?.masterKey?.id &&
                                      !kba?.assignment?.reserved &&
                                      kba?.isCombine &&
                                      (kba.combineType === 4 || kba.combineType === 5 || kba.combineType === 7)
                                    "
                                    (click)="separateLine(kba)"
                                  >
                                    <mat-icon color="rgba(0, 0, 0, 0.54)" class="phx-to-mat-icon">fullscreen</mat-icon>
                                    Separate
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      !kba?.assignment?.reserved &&
                                      !kba?.assignment?.masterKey?.id &&
                                      !kba?.isCombine &&
                                      !kba?.isASplit &&
                                      page.columns.length > 1
                                    "
                                    (click)="combineKbaAcross(page, block, kba)"
                                    (mouseenter)="previewCombineKbaAcross(page, block, kba)"
                                    (mouseleave)="previewCombineKbaAcross(page, block, kba)"
                                  >
                                    <mat-icon style="transform: rotate(90deg)">unfold_less</mat-icon>Combine
                                    Horizontally
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      !kba?.assignment?.reserved &&
                                      !kba?.assignment?.masterKey?.id &&
                                      !kba?.isCombine &&
                                      !kba?.isASplit &&
                                      column.blocks.length > 1
                                    "
                                    (click)="combineKbaVertical(column, kba)"
                                    (mouseenter)="previewCombineKbaVertical(column, kba)"
                                    (mouseleave)="previewCombineKbaVertical(column, kba)"
                                  >
                                    <mat-icon>unfold_less</mat-icon>Combine Vertically
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="
                                      !kba?.assignment?.reserved &&
                                      !kba?.assignment?.masterKey?.id &&
                                      !kba?.isCombine &&
                                      !kba?.isASplit &&
                                      selectedBook.pages.length > 1
                                    "
                                    (click)="combineBittingStack(selectedBook, column, block, kba)"
                                    (mouseenter)="previewcombineBittingStack(selectedBook, column, block, kba)"
                                    (mouseleave)="previewcombineBittingStack(selectedBook, column, block, kba)"
                                  >
                                    <mat-icon>compress</mat-icon>Combine Stack
                                  </button>
                                  <button
                                    mat-menu-item
                                    *ngIf="kba?.assignment?.masterKey?.id || kba?.assignment?.reserved"
                                    (click)="unassignKbas(kba)"
                                  >
                                    <mat-icon>delete_outline</mat-icon>Unassign
                                  </button>
                                </mat-menu>
                              </div>
                            </div>

                            <!-- Drop Menu Button -->
                            <div class="col flex-center end">
                              <button
                                *ngIf="!kba?.children"
                                [disabled]="kba.disabled"
                                class="handle"
                                mat-icon-button
                                [matMenuTriggerFor]="actions"
                              >
                                <mat-icon>drag_handle</mat-icon>
                              </button>

                              <button
                                *ngIf="kba?.children && canSplit(kba)"
                                matTooltipShowDelay="400"
                                matTooltip="Merge Bittings"
                                class="handle"
                                (click)="mergeSplit(kba)"
                                mat-icon-button
                              >
                                <mat-icon>call_merge</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
